// extracted by mini-css-extract-plugin
module.exports = {"section":"Accessories_section__5sqwc"};